import { useSearchParams } from 'next/navigation';

import { useRetainedValue } from '~hooks/useRetainedValue';
import { usePathname, useRouter } from '~i18n/navigation';
import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';
import { updateQueryParamsWithPathname } from '~utils/searchParams';

import type {
	BotWizardFieldColor,
	BotWizardFieldNames,
	BotWizardValues,
} from '../../model/types';
import { getDependencyContent } from '../../model/utils';
import { WorkingArea } from '../styles';
import { ColorIcon, StyledFieldColor } from './styles';

export const FieldColor = ({
	data,
	contentDependency,
	values,
	id,
	queryKey,
	multiSelect,
}: BotWizardFieldColor & {
	id: BotWizardFieldNames;
	values: BotWizardValues;
}) => {
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const router = useRouter();

	const [value, setValue] = useRetainedValue(
		values[id] as string | string[] | undefined,
		(v) => {
			router.push(
				updateQueryParamsWithPathname({ [queryKey]: v }, pathname, searchParams)
			);
		}
	);
	// TODO support multiselect
	if (multiSelect) return null;

	const localData = getDependencyContent({
		data,
		contentDependency,
		values,
	});

	return (
		<WorkingArea>
			<StyledFieldColor>
				{localData?.map((el) => (
					<ButtonIconGhost
						onClick={() => setValue(el.id)}
						size="M"
						bigIcon={true}
						selected={value === el.id}
						leftIcon={<ColorIcon color={el.value} />}
						key={el.id}
					/>
				))}
			</StyledFieldColor>
		</WorkingArea>
	);
};
